import { CourseHomeConstants } from '../_constants';

export function courseHome(state = {}, action) {
  switch (action.type) {
    case CourseHomeConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case CourseHomeConstants.GETALL_SUCCESS:
      return {
        courses: action.courses
      };
    case CourseHomeConstants.GETALL_FAILURE:
      return { 
        error: action.error
      };

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/course-home.reducer.js